import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Banner from '../components/Banner';
import Reaction from '../components/Reaction';
import Contact from '../components/Contact';
import LastUpdate from '../components/LastUpdate';

const FaqRegisterKtp = () => {
    React.useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);

    return (
        <div className="bg-white min-h-screen  flex flex-col">
            <Navbar />
            
            {/* Banner Section */}
            <Banner
                image={process.env.REACT_APP_S3 + "banner_faq.png"} 
                beforePage="FAQ"
                currentPage="Detail FAQ" 
            />
            <div className="mx-auto px-4 md:px-24 w-full relative z-10 mb-16">
                <div className="rounded-2xl md:rounded-3xl">
                    <div className="mb-10 md:mb-16 max-w-4xl">
                        <h1 className="text-2xl md:text-3xl lg:text-3xl font-bold text-[#101828] mb-6 leading-snug">
                            Kenapa saya turun jadi green member, apa perbedaan nya?
                        </h1>
                    </div>

                    {/* Mapping Blok Konten (Kiri Teks, Kanan Gambar) */}
                    <div className="flex flex-col gap-12 md:gap-20">
                      <div className="flex flex-col md:flex-row gap-8 md:gap-12">
                          <div className="w-full md:w-1/2 text-left justify-center md:justify-end">
                              <label className="text-[#101828] text-md md:text-md">
                                Turunnya level membership menjadi Green Member di aplikasi Summarecon bisa disebabkan oleh
                              </label>
                              <p className="mt-4 text-[#475467] text-md md:text-md">
                                User gagal mengumpulkan 52 premium stamp dalam 1 periode
                              </p>

                              <p className="mt-4 text-[#475467] text-md md:text-md">
                                Aktifitas apa saja agar bisa mengumpulkan 52 stamp?
                              </p>
                              
                              <ol className="list-decimal pl-5 mt-4 text-[#475467]">
                                <li className="mb-4">
                                  <strong className="text-[#101828]">Belanja di Summarecon Mall:</strong> 
                                  {" "}Belanja dan upload struk belanja minimal Rp.25.000.000 dalam 1 periode
                                </li>
                                <li className="mb-4">
                                  <strong className="text-[#101828]">Daftarkan properti:</strong>
                                  {" "}Jika kamu mempunyai properti di summarecon, kamu bisa mendaftarkan di aplikasi Summarecon Home Apps
                                </li>
                              </ol>
                          </div>

                          {/* Kolom Kanan: Gambar */}
                          <div className="w-full md:w-1/2 flex justify-center md:justify-end">
                              {/* Box background hijau/abu-abu muda seperti di desain */}
                              <div className="rounded-3xl px-6 md:px-8 w-full max-w-[640px] flex justify-center items-center">
                                  <img
                                      src={process.env.REACT_APP_S3+"down_to_green.png"}
                                      className="w-full h-auto object-contain drop-shadow-xl"
                                  />
                              </div>
                          </div>
                      </div>
                    </div>
                    <LastUpdate/>
                </div>
            </div>
            <Contact />
            <Footer />
        </div>
    );
}

export default FaqRegisterKtp;